export default class HelpTypeQuestionModel {
    constructor() {
        this.id = 0;
        this.name = "";
        this.icon = "";
        this.parentId = 0;
        this.indexPos = 0;
        this.colorIcon = "";
    }
}